import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function HomePage() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'http://jtqzai.cn/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    logo: 'http://jtqzai.cn/logo.png',
    description: siteInfo.description,
    foundingDate: `${siteInfo.foundedYear}`,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.contact.email,
      contactType: '客户服务',
    },
    sameAs: [
      siteInfo.url,
    ],
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - 51黑料吃瓜网在线观看`,
    description: siteInfo.description,
    url: `${siteInfo.url}/`,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
    },
    about: {
      '@type': 'Thing',
      name: '娱乐八卦爆料',
      description: '明星塌房、每日黑料、独家猛料等娱乐新闻内容',
    },
  };

  const articleListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: articles.slice(0, 10).map((article, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Article',
        headline: article.title,
        description: article.summary,
        url: `${siteInfo.url}/article/${article.id}`,
        datePublished: article.publishDate,
        author: {
          '@type': 'Person',
          name: article.author,
        },
        image: article.image,
      },
    })),
  };

  return (
    <>
      <title>51黑料网 - 51黑料吃瓜网在线观看 | 每日黑料大赛明星塌房现场</title>
      <meta
        name="description"
        content="51黑料网整合51黑料吃瓜网在线观看入口、每日黑料大赛与明星塌房现场爆料。本页提供不打烊的独家猛料实时追踪，聚合全网黑料大瓜，满足吃瓜用户一站式浏览需求。"
      />
      <meta
        name="keywords"
        content="51黑料网,51黑料吃瓜网,51黑料在线观看,51黑料吃瓜网在线观看,每日黑料大赛,51黑料不打烊,51黑料网今日黑料,51黑料网站,51黑料视频,51黑料吃瓜入口"
      />
      <link rel="canonical" href="http://jtqzai.cn/" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="51黑料网 - 51黑料吃瓜网在线观看" />
      <meta
        property="og:description"
        content="51黑料网整合51黑料吃瓜网在线观看入口、每日黑料大赛与明星塌房现场爆料。"
      />
      <meta property="og:url" content="http://jtqzai.cn/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="51黑料网 - 51黑料吃瓜网在线观看" />
      <meta
        name="twitter:description"
        content="51黑料网整合51黑料吃瓜网在线观看入口、每日黑料大赛与明星塌房现场爆料。"
      />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(articleListSchema)}</script>

      <div className="min-h-screen flex flex-col bg-background-950">
        <header>
          <Navbar />
        </header>

        <main>
          <HeroSection />
          <TrendingSection />
          <CategorySection />
          <LatestSection />
        </main>

        <Footer />
      </div>
    </>
  );
}
